import { Box, Typography, IconButton, Badge, useTheme } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const StoreHeader = ({ cartCount, onCartClick }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3, display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
      <Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            mb: 1,
          }}
        >
          Store
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
          }}
        >
          Strategy store
        </Typography>
      </Box>
      <IconButton
        onClick={onCartClick}
        sx={{
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        }}
      >
        <Badge badgeContent={cartCount} color="primary">
          <ShoppingCartIcon sx={{ color: theme.palette.text.primary }} />
        </Badge>
      </IconButton>
    </Box>
  );
};

export default StoreHeader;
